import { render, staticRenderFns } from "./TableOperaBtn.vue?vue&type=template&id=0624d07e&"
import script from "./TableOperaBtn.vue?vue&type=script&lang=ts&"
export * from "./TableOperaBtn.vue?vue&type=script&lang=ts&"
import style0 from "./TableOperaBtn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports